import PropTypes from "prop-types";
import React, { Component } from "react";
import { Avatar, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { connect } from "react-redux";
import {
  addFieldData,
  setItemBreadcrumbs,
  setReturnedValue,
  setMessageWithCode
} from "../actions";
import PriorityCode from "./PriorityCode";
import AlertDialog from "./AlertDialog";

class Chooser extends Component {
  state = {
    value: "",
    dataValue: ""
  };

  componentDidMount() {
    this.props.step.data.fetchSource &&
      this.props.fetchData(this.props.step.data.fetchSource);
  }

  componentWillUnmount() {
    const dataKey = this.props.step.data.keyValue;
    this.props.resetData(dataKey);
  }

  getData = () => {
    const stepData = this.props.step.data;
    const dataKey = stepData.keyValue;
    if (this.props.dataSource && this.props.dataSource[dataKey]) {
      let data = this.props.dataSource[dataKey];
      if (data && stepData.formatSource) {
        data = stepData.formatSource(data);
      }
      return data;
    }
    return null;
  };

  getRenderRadio = data => {
    if (data) {
      return data.map(item => {
        return (
          <FormControlLabel
            key={item.key}
            value={item.value}
            datavalue={item.dataValue}
            control={<Radio color="primary" />}
            label={
              <div className="item-label">
                <Avatar src={item.avatar} />
                <span className="text">{item.label}</span>
              </div>
            }
            labelPlacement="end"
          />
        );
      });
    }
    return [];
  };

  handleChange = event => {
    const returnedKey = this.props.step.returned.key;
    const returnedDataKey = this.props.step.returned.dataKey
      ? this.props.step.returned.dataKey
      : returnedKey;
    const value = event.target.value;
    const dataValue = event.currentTarget.attributes.datavalue
      ? event.currentTarget.attributes.datavalue.value
      : value;
    this.buildBreadcrumbs(value);
    if (returnedKey && value !== "") {
      this.props.isValid(true);
      this.props.setReturnedValue({
        [returnedKey]: value,
        [returnedDataKey]: dataValue
      });
    } else {
      this.props.isValid(false);
    }
    this.setState({ value, dataValue });
  };

  handleErrorClose = () => {
    this.props.setMessageWithCodeFunc("");
  };

  buildBreadcrumbs = value => {
    let data = this.getData();
    data.forEach(item => {
      if (item.value === value) {
        let element = {
          textItem: item.label,
          stepItem: { ...this.props.activeStep }
        };
        this.props.setBreadcrumbs(element);
      }
    });
  };

  render() {
    const { step } = this.props;
    let data = this.getData();
    return (
      <div className="wrap-chooser text-grey">
        <label>
          {step.icon && <img src={step.icon} alt={step.label} />}
          <strong>{step.label}</strong>
        </label>
        {data && (
          <div className="content-chooser">
            <RadioGroup
              aria-label={step.label}
              name={"chooser"}
              onChange={this.handleChange}
            >
              {this.getRenderRadio(data)}
            </RadioGroup>
          </div>
        )}
        {step.showLinkPriorityCode &&
          this.props.isShowLinkPriorityCode &&
          this.props.isFromAdmin !== "admin" && <PriorityCode />}
        {this.props.messageWithCode && this.props.messageWithCode.text && (
          <AlertDialog
            content={this.props.messageWithCode.text}
            onClick={this.handleErrorClose}
          />
        )}
      </div>
    );
  }
}

Chooser.propTypes = {
  activeStep: PropTypes.any,
  dataSource: PropTypes.any,
  fetchData: PropTypes.func,
  isFromAdmin: PropTypes.string,
  isShowLinkPriorityCode: PropTypes.any,
  isValid: PropTypes.func,
  resetData: PropTypes.func,
  setBreadcrumbs: PropTypes.func,
  setReturnedValue: PropTypes.func,
  messageWithCode: PropTypes.shape({
    text: PropTypes.string,
    code: PropTypes.number
  }),
  step: PropTypes.shape({
    data: PropTypes.shape({
      fetchSource: PropTypes.func,
      formatSource: PropTypes.func,
      keyValue: PropTypes.any
    }),
    icon: PropTypes.any,
    label: PropTypes.any,
    returned: PropTypes.shape({
      dataKey: PropTypes.any,
      key: PropTypes.any
    }),
    showLinkPriorityCode: PropTypes.any
  }),
  setMessageWithCodeFunc: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    activeStep: state.activeStep,
    isShowLinkPriorityCode: state.configuration.baffcodeprioritaire,
    isFromAdmin: state.returnedValue.from,
    messageWithCode: state.messageWithCode
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: functionName => dispatch(functionName()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    setBreadcrumbs: item => dispatch(setItemBreadcrumbs(item)),
    resetData: key => dispatch(addFieldData(key, null)),
    setMessageWithCodeFunc: message => dispatch(setMessageWithCode(message))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chooser);
